import { tmrResourceFormController } from 'tmr/controllers/resourceForm/resourceForm'
import templateUrl from './form.html'

/**
 * Add Hierarchies route
 *
 * @namespace routes.AdminHierarchiesAdd
 * @type {TmrRoute}
 */
export const route = {
  name: 'admin.hierarchies.add',
  params: {
    parent: null,
    submitAndContinue: null,
  },
}

/**
 * Hierarchy add/edit form component.
 *
 * @type {ngComponent}
 */
export const tmrAdminHierarchyForm = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrAdminHierarchyFormController',
  bindings: {
    resource: '<',
    toast: '<',
  },
}

/**
 * Controller of component {@link tmrAdminHierarchyForm}.
 *
 * @type {ngController}
 */
export class tmrAdminHierarchyFormController extends tmrResourceFormController {
  constructor(
    $scope,
    $state,
    $stateParams,
    TmrInvalidFormError,
    TmrToast,
    Hierarchy
  ) {
    'ngInject'
    super($scope, $state, $stateParams, TmrInvalidFormError, TmrToast)
    Object.assign(this, { Hierarchy })
  }

  $onInit() {
    super.$onInit()

    if (this.$stateParams.parent) {
      this.resource.parent = this.$stateParams.parent
      this.parentText = this.$stateParams.parent.description
    }
  }

  /** Query to get hierarchies for md-autocomplete and code notEquals to resource.code. */
  getHierarchies(value) {
    return this.Hierarchy.search({ value }).$promise.then(response =>
      response.filter(obj => obj.code != this.resource.code)
    )
  }

  /** Override onSavedContinue callback */
  onSavedContinue() {
    return this.$state
      .go(
        this.$state.current,
        { parent: this.resource.parent, submitAndContinue: true },
        { reload: true, inherit: false }
      )
      .then(this.TmrToast.success(this.toast))
  }
}
